import React from 'react';
import { ModalButtonSave, ModalButtonUpdate } from '../../constant';
import { Dialog } from 'primereact/dialog';
import { FormMicCharacteristic } from './FormMicCharacteristic';
export const DialogMicCharacteristic = ({
  visible,
  setVisible,
  handleInputChange,
  saveCreateCharacteristic,
  saveUpdateCharacteristic,
  loading,
  method,
  formValues,
}) => {
  console.log("🚀 ~ DialogMicCharacteristic ~ formValues:", formValues)

  return (
    <Dialog
      header={
        method === "create" ? "Crear Caracteristica" :
          method === "update" ? "Actualizar Caracteristica" : null
      }
      visible={visible}
      headerStyle={{
        backgroundColor: '#0d3b59',
        color: 'white',
        fontWeight: 'bold',
      }}
      pt={{
        header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
        headerIcon: { style: { color: 'white' } },
      }}
      onHide={() => setVisible(false)}
      className="pt-0"
      footer={null}
    >
      {(method === "create" || method === "update") && (
        <FormMicCharacteristic
          button={method === "create" ? "Guardar" : "Actualizar"}
          handleInputChange={handleInputChange}
          loading={loading}
          onSubmit={method === "create" ? saveCreateCharacteristic : saveUpdateCharacteristic}
          characteristic={formValues.characteristic}
        
        />
      )}
    </Dialog>
  );
};

